const {registerModule, KitModule} = window;

class LocationList extends KitModule {
  constructor($element) {
    super($element);
    this.initialize();
  }

  initialize() {
    this.setVars();
    setInterval(() => {
      this.setTimeUi();
    }, 1000);
  }

  setVars() {
    this.locale = document.documentElement.lang;
  }

  getTimeZone(timezone) {
    if (!timezone) {
      return;
    }

    const currentTime = new Date().toLocaleTimeString(this.locale, {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });


    return currentTime;
  }

  setTimeUi() {
    this.$locationItem.forEach(($location) => {
      const tz = $location.getAttribute('data-zone');
      const zone = this.getTimeZone(tz);
      const timeUi = $location.querySelector('.js-time');

      if (zone) {
        timeUi.innerHTML = `${zone}`;
      }
    });
  }
}

registerModule('LocationList', LocationList);
